import React, { Component } from 'react';
import './CreateDrugModal.css';
import models from '../../../model/models';
import Label from '../../../components/label/Label';
import Button from '../../../components/button/Button';
import mainAPI from '../../../api/MainAPI';
import moment from 'moment';
import Input from '../../../inputs/input/Input';
import toasts from '../../../utils/toasts';
import Volume from '../../../components/volume/Volume';
import cloneDeep from 'lodash.clonedeep';
import UniversalDropDown from '../../../components/universalDropDown/UniversalDropDown';
import { getDisplayUnit } from '../../../utils/gramUtils';

class CreateDrugModal extends Component {
	constructor() {
		super();
		this.state = {
			codeError: false,
			codeTouched: false,
			types: {},
			touched: {
				type: false,
				barcode_id: false,
				drug_box_id: false,
				lot_number: false,
				expiration_date: false,
				quantity: false
			},
			drug: {
				type: '',
				barcode_id: '',
				drug_box_id: '',
				lot_number: '',
				expiration_date: '',
				quantity: 0
			}
		};
    this.myRefs = {};
	}

	_touchField = (field) => {
		const { touched, drug } = this.state;
		let valid = drug[field];
		this.setState({
			touched: { ...touched, [field]: !valid }
		});
	};

	_throwCodeValid = (bool) => {
		this.setState({
			codeError: bool
		});
	};

	_codeFieldTouched = () => {
		this._touchField('barcode_id');
		this.setState({
			codeTouched: true
		});
	};

	_onHandleChange = (field, value) => {
		const { drug } = this.state;
		if (field === 'barcode_id') {
			this._throwCodeValid(value.length < 3);
		}
		this.setState({
			drug: { ...drug, [field]: value }
		});
	};
	_codeUsed = async ({barcode_id}) => {
		const promises = [];
		promises.push(mainAPI.drug.find_by_barcode({ barcode_id }));
		promises.push(mainAPI.drug_box.find_by_barcode({ barcode_id }));
		const [drug, box] = await Promise.all(promises);
		if(!drug && !box)return false;
		return true;
	};

	_createNewDrug = async () => {
		const { codeError, drug, drug: { expiration_date } = {} } = cloneDeep(this.state);
		const { onClose } = this.props;
		const {valid, required} = this._checkAllFields();
		if (required.length === 1) {
			return toasts.show(`${required[0]} is required.`);
		}
		if (required.length > 1) {
			return toasts.show(`${required.join(', ')} fields are required.`);
		}
		let futureDate = new Date() < new Date(expiration_date);
		if (!futureDate) {
			return toasts.show('The expiration date is in the past');
		}
		const used = await this._codeUsed(drug);
		if (used) {
			return toasts.show('This code is already in use');
		}
		if (drug.quantity <= 0) {
			return toasts.show('You need a positive Dosage');
		}
		if (valid && futureDate && !codeError) {
			drug.quantity = Volume.toMicrograms(drug.quantity, drug.type);
			drug.barcode_id = drug.barcode_id.trim();
			let res = await models.drug.save({ ...drug });
			if (!res) return toasts.show('Drug was not created');
			models.drug.refreshData();
			onClose();
		}
	};

	_checkAllFields = () => {
		const { drug, drug: { type, barcode_id, drug_box_id, lot_number, expiration_date, quantity } = {} } = this.state;
		this.setState({
			touched: {
				type: !type,
				barcode_id: !barcode_id,
				drug_box_id: !drug_box_id,
				lot_number: !lot_number,
				expiration_date: !expiration_date,
				quantity: !quantity
			}
		});

		const labels = {
			type: 'Type',
			barcode_id: 'Code',
			drug_box_id: 'Drug Box',
			lot_number: 'Lot Number',
			expiration_date: 'Expires On',
			quantity: 'Dosage'
		}

		const failed = [];
		// eslint-disable-next-line array-callback-return
		Object.keys(drug).map((field) => {
			if (!drug[field]) {
				failed.push(labels[field]);
			}
		});
		return {valid: failed.length < 1, required: failed}
	};

  cycleTab = (e) => {
    e.preventDefault();
    this.myRefs.code.focus()
  };

	render() {
		const {
			codeError,
			codeTouched,
			drug: { type, barcode_id, drug_box_id, lot_number, expiration_date, quantity } = {},
			touched: {
				type: typeTouched,
				barcode_id: barcode_idError,
				drug_box_id: drugBoxTouched,
				lot_number: lot_numberError,
				expiration_date: expiration_dateError,
				quantity: quantityError
			} = {}
		} = this.state;
		const { onClose } = this.props;
		return (
			<div className="g-create-drug-modal">
				<div className="g-create-drug-modal-popup">
					<div className="g-create-drug-modal-background" onClick={onClose} />
					<div className="g-create-drug-modal-modal">
						<div className="g-create-drug-modal-card g-create-drug-modal-card-create">
							<Label black large className="g-create-drug-modal-card-create-label">
								Add Drug
							</Label>
							<div className="g-create-drug-modal-create">
								<div>
									<div className="g-create-drug-modal-create-field">
										<Label className="g-create-drug-modal-create-field-label" gray-medium>
											Code
										</Label>
										<Input
											className={`g-create-drug-modal-create-field-input-field ${
												barcode_idError || (codeError && codeTouched) ? 'g-create-drug-modal-create-field-error' : ''
											}`}
											onBlur={this._codeFieldTouched}
											onChange={(e) => {
												this._onHandleChange('barcode_id', e);
											}}
											value={barcode_id}
                      ref={ref=>this.myRefs.code = ref}
										/>
										{codeError &&
											(codeTouched && (
												<div className="g-create-drug-modal-create-field-error-text">Drug code too short</div>
											))}
									</div>
									<div className="g-create-drug-modal-create-field">
										<Label className="g-create-drug-modal-create-field-label" gray-medium>
											Dosage {getDisplayUnit(type)}
										</Label>
										<Input
											className={`g-create-drug-modal-create-field-input-field ${
												quantityError ? 'g-create-drug-modal-create-field-error' : ''
											}`}
											onBlur={() => {
												this._touchField('quantity');
											}}
											type="number"
											onChange={(e) => {
												this._onHandleChange('quantity', e);
											}}
											value={quantity}
										/>
									</div>
									<div className="g-create-drug-modal-create-field">
										<Label className="g-create-drug-modal-create-field-label" gray-medium>
											Lot Number
										</Label>
										<Input
											className={`g-create-drug-modal-create-field-input-field ${
												lot_numberError ? 'g-create-drug-modal-create-field-error' : ''
											}`}
											onBlur={() => {
												this._touchField('lot_number');
											}}
											onChange={(e) => {
												this._onHandleChange('lot_number', e);
											}}
											value={lot_number}
										/>
									</div>
								</div>
								<div>
									<div className="g-create-drug-modal-create-field">
										<Label className="g-create-drug-modal-create-field-label" gray-medium>
											Expires On
										</Label>
										<Input
											min={moment(new Date()).format('YYYY-MM-DD')}
											className={`g-create-drug-modal-create-field-input-field ${
												expiration_dateError ? 'g-create-drug-modal-create-field-error' : ''
											}`}
											onBlur={() => {
												this._touchField('expiration_date');
											}}
											type="date"
											onChange={(value) => {
												this._onHandleChange('expiration_date', value);
											}}
											value={moment(expiration_date).format('YYYY-MM-DD')}
										/>
									</div>
									<div className="g-create-drug-modal-create-field">
										<Label className="g-create-drug-modal-create-field-label" gray-medium>
											Drug Box
										</Label>
										<UniversalDropDown
											placeholder={'Drug Box'}
											className={`g-create-drug-modal-create-field-input-field ${
												(drugBoxTouched && !drug_box_id) ? 'g-create-drug-modal-create-field-error' : ''
											}`}
											onBlur={() => {
												const { touched: {drugBoxOpened = false} } = this.state;
												if (drugBoxOpened) this._touchField('drug_box_id');
											}}
											onClick={() => {
												const { touched } = this.state;
												this.setState({
													touched: { ...touched, drugBoxOpened: true }
												});
											}}
											required
											value={drug_box_id}
											onChange={(e) => {
												this._onHandleChange('drug_box_id', e);
											}}
											endpoint={mainAPI.drug_box.all}
										/>
									</div>
									<div className="CreateDrugModal-create-field">
										<Label className="g-create-drug-modal-create-field-label" gray-medium>
											Type
										</Label>
										<UniversalDropDown
											placeholder={'Type'}
											className={`g-create-drug-modal-create-field-input-field ${
												(typeTouched && !type) ? 'g-create-drug-modal-create-field-error' : ''
											}`}
											onBlur={() => {
												const { touched: {typeOpened = false} } = this.state;
												if (typeOpened) this._touchField('type');
											}}
											onClick={() => {
												const { touched } = this.state;
												this.setState({
													touched: { ...touched, typeOpened: true }
												});
											}}
											required
											endpoint={mainAPI.drug_type.allowed_drugs}
											onChange={(e) => {
												this._onHandleChange('type', e);
											}}
											value={type}
										/>
									</div>
								</div>
							</div>
							<div className="g-create-drug-modal-card-actions">
								<Button className="g-create-drug-modal-card-actions-button" color="white" bg="red" onClick={onClose}>
									Cancel
								</Button>
								<Button
									className="g-create-drug-modal-card-actions-button"
									color="white"
									bg="blue"
									onClick={this._createNewDrug}
                  onKeyDown={this.cycleTab}
								>
									Add Drug
								</Button>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default CreateDrugModal;



// WEBPACK FOOTER //
// ./src/cards/drugCard/createDrugModal/CreateDrugModal.jsx